import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const adminSettingsApi = createApi({
    reducerPath: "adminSettings",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['adminSettings' ,'admin'],
    endpoints: (builder) => ({
        // ---------------------- LEGALS ----------------------
        updateSetting: builder.mutation({
            query: ({ _id, data }) => ({
                url: `/admin/update-legals`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['adminSettings'],
        }),
        getAdminLegal: builder.query({
            query: ({type}) => ({
                url: `/admin/legal?type=${type}`,
                method: "GET",
            }),
            transformResponse: (res) => res?.body,
            providesTags: ['adminSettings']
        }),
        adminNotifyAll: builder.mutation({
            query: (data) => ({
                url: `/admin/notify-all`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['adminSettings'],
        }),
        getUserEmail: builder.query({
            query: ({keyword}) => ({
                url: `/admin/search-user-emails?keyword=${keyword}`,
                method: "POST",
            }),
            transformResponse: (res) => res?.body,
            providesTags: ['adminSettings']
        }),
        sendBulkEmail: builder.mutation({
            query: (data) => ({
                url: `/admin/send-bulk-mails`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['adminSettings'],
        }),

        updateAdminSettings: builder.mutation({
            query: ({ data }) => ({
                url: `/admin/update-settings`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['admin'],
        }),

        getAdminSettings: builder.query({
            query: () => ({
                url: `/admin/fetch-settings`,
                method: 'GET',
            }),
            providesTags: ['admin'],
        }),

        

    }),
});

export const {
    useUpdateSettingMutation,
    useGetAdminLegalQuery,
    useAdminNotifyAllMutation,
    useGetUserEmailQuery,
    useSendBulkEmailMutation,
    useGetAdminSettingsQuery,
    useUpdateAdminSettingsMutation
} = adminSettingsApi;